var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopContries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17262",
    "data-name": "Group 17262",
    transform: "translate(19729 15818)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2239",
    "data-name": "Rectangle 2239",
    width: 16,
    height: 16,
    transform: "translate(-19729 -15818)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "waving-flag-",
    transform: "translate(-19753.732 -15817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8319",
    "data-name": "Path 8319",
    d: "M66.787,16.693a3.616,3.616,0,0,1,3.224-.365c1.824.759,2.474,2.262,5.241.274.237-.171.423-.081.423.211v5.179a1.342,1.342,0,0,1-.382.894,3.651,3.651,0,0,1-2.306,1.006c-1.416-.044-2.787-1.548-4.07-1.548a4.46,4.46,0,0,0-2.123.683c-.252.149-.443.053-.443-.239V17.52A1.065,1.065,0,0,1,66.787,16.693Z",
    transform: "translate(-37.691 -15.307)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8320",
    "data-name": "Path 8320",
    d: "M27.51,0a.777.777,0,0,0-.777.777.763.763,0,0,0,.065.309,2.2,2.2,0,0,1,.183.786v11.45a.529.529,0,0,0,1.058,0V1.871a2.205,2.205,0,0,1,.182-.786.763.763,0,0,0,.065-.309A.776.776,0,0,0,27.51,0Z",
    transform: "translate(0)",
    fill: "#f9b316"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopContries);
export default __webpack_public_path__ + "static/media/top_contries.1596931ccd51654e3c0bb6b13dbbac42.svg";
export { ForwardRef as ReactComponent };